import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M5.07 29.15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m24.98 10.8 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM112.64 52.07h-5.57V46.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H98.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path fill="#0597A3" d="M43.5 109a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M93.53 29.09c0-3.71-3.01-6.72-6.72-6.72H29.2c-3.71 0-6.73 3.01-6.73 6.72v17.34h71.06z"
    />
    <path
      fill="#0597A3"
      d="M22.47 46.43V86.7c0 3.71 3.01 6.72 6.73 6.72h57.61c3.71 0 6.72-3.01 6.72-6.72V46.43z"
    />
    <path
      fill="#001A43"
      d="M82.47 52.77h-5.02a2.2 2.2 0 0 0-2.2 2.2v5.02a2.2 2.2 0 0 0 2.2 2.2h5.02a2.2 2.2 0 0 0 2.2-2.2v-5.02a2.2 2.2 0 0 0-2.2-2.2"
    />
    <path
      fill="#0597A3"
      d="M40.41 30.63c-1.24 0-2.25-1.01-2.25-2.25V17.4c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10.98c0 1.24-1.01 2.25-2.25 2.25M75.59 30.63c-1.24 0-2.25-1.01-2.25-2.25V17.4c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10.98c0 1.24-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#001A43"
      d="M39.3 52.77h-5.02a2.2 2.2 0 0 0-2.2 2.2v5.02a2.2 2.2 0 0 0 2.2 2.2h5.02a2.2 2.2 0 0 0 2.2-2.2v-5.02a2.2 2.2 0 0 0-2.2-2.2M61.78 52.77h-5.02a2.2 2.2 0 0 0-2.2 2.2v5.02a2.2 2.2 0 0 0 2.2 2.2h5.02a2.2 2.2 0 0 0 2.2-2.2v-5.02a2.2 2.2 0 0 0-2.2-2.2M39.3 71.74h-5.02a2.2 2.2 0 0 0-2.2 2.2v5.02a2.2 2.2 0 0 0 2.2 2.2h5.02a2.2 2.2 0 0 0 2.2-2.2v-5.02a2.2 2.2 0 0 0-2.2-2.2M61.78 71.74h-5.02a2.2 2.2 0 0 0-2.2 2.2v5.02a2.2 2.2 0 0 0 2.2 2.2h5.02a2.2 2.2 0 0 0 2.2-2.2v-5.02a2.2 2.2 0 0 0-2.2-2.2"
    />
    <path
      fill="#00D8D8"
      d="M7.57 58.48c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M87 103c10.49 0 19-8.51 19-19s-8.51-19-19-19-19 8.51-19 19 8.51 19 19 19"
    />
    <path
      fill="#001A43"
      d="M95.25 87.75c0-3.65-2.65-6-6.75-6h-3c-2.25 0-2.25-.98-2.25-1.5s0-1.5 2.25-1.5H92c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25h-2.75V74c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25v.28c-3.67.27-6 2.56-6 5.97 0 3.65 2.65 6 6.75 6h3c2.25 0 2.25.98 2.25 1.5s0 1.5-2.25 1.5H82c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h2.75V94c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-.28c3.67-.27 6-2.56 6-5.97"
    />
  </svg>
);
const SvgEnrichedIconSchedulePaymentInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSchedulePaymentInverted);
export default Memo;
